<template>
    <div>
        <div class="open-plat">
            <div class="open-header-wrap">
                <div class="header-layout clearfix">
                    <div class="header-layout-side">
                        <a v-app-url="'/'" class="header-layout-logo">
                            <img v-resc-url="'/image/logo.png'" title="商维宝开放平台">
                            <span>商维宝开放平台</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="banner-wrap">
                <div class="banner-layout clearfix">
                    <div class="login-layout">
                        <div class="login-area">
                            <div class="login-title">
                                <span>登录</span>
                            </div>
                            <el-form :model="user" :rules="rules" ref="user" class="demo-ruleForm" @keyup.enter.native="submitForm('user')">
                                <div class="login-form-panel">
                                    <el-form-item prop="phoneNo">
                                        <div class="login-input">
                                            <el-input v-model="user.phoneNo" class="font14" type="text" placeholder="请输入手机号码或集团编码" auto-complete="off"></el-input>
                                        </div>
                                    </el-form-item>
                                    <el-form-item prop="password">
                                        <div class="login-input">
                                            <el-input v-model="user.password" class="font14" type="password" placeholder="密码" auto-complete="off"></el-input>
                                        </div>
                                    </el-form-item>
                                </div>
                                <div class="login-help-panel clearfix">
                                    <label class="checkbox-label">
                                        <input type="checkbox">
                                        <span class="ml5">记住账号</span>
                                    </label>
                                    <!--<a title="找回密码" class="help-link">找回密码</a>-->
                                </div>
                                <div class="login-btn-panel">
                                    <el-button type="primary" @click="submitForm('user');" class="swb-btn swb-btn-small">登录</el-button>
                                </div>
                            </el-form>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {$} from '../../app.base'
import {Vue, MsgBox} from '../../app.vues'

import userApi from '../../api/user'

export default {
    data: function () {
        var checkPhoneNo = function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                return callback(new Error('登录账号不能为空'));
            } else {
                if (!Utils.isMobileNo(value)) {
                    let prefixStr = value.substring(0, 2);
                    if (prefixStr != "JT") {
                        return callback(new Error('请输入正确的手机号或集团编号'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            }
        };
        var validatePass = function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('请输入密码'));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            //
            item: {name: '登录', type: 'login'},
            user: {},
            loginFlag: true,
            rules: {
                phoneNo: [{
                    validator: checkPhoneNo,
                    trigger: 'blur'
                }],
                password: [{
                    validator: validatePass,
                    trigger: 'blur'
                }]
            }
        }
    },
    mounted: function () {
        let appMockMode = isAppMockMode();
        //
        if (appMockMode) {
            Vue.$showDialog({
                title: "商维宝-重要公告提醒",
                showCloseBtn: false,
                okVisible: false,
                cancelText: "知道了",
                width: 600,
                height: 300,
                centerButtons: true,
                template: '<div>\
                <p style="text-indent: 2em;font-size: 16px;font-weight: 600;color: red;margin-top: 10px;">亲爱的用户，为了给您提供更好的服务，我们一直在奋战！</p>\
                <p style="text-indent: 2em;font-size: 16px;font-weight: 600;color: red;margin-top: 10px;">期盼已久的功能将要发布，当前数据仅用于内部模拟验证。</p>\
                </div>',
                data: {},
                methods: {}
            });
        }
        // this.inputName = this.name || '请输入';
    },
    methods: {
        //
        submitForm: function (formName) {
            var self = this;
            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    self.submit();
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        submit: function () {
            var self = this;
            if (self.loginFlag == false) {
                return false;
            }
            //
            self.loginFlag = false;
            //
            self.loading = true;
            var postData = self.user;
            userApi.doUserLogin(postData, function (result, jqXhr) {
                //
                if (result.type == "info") {
                    self.loginFlag = true;
                    // MsgBox.success("登录成功");
                    window.location.href = getAppUrl(result.data);
                } else {
                    self.loading = false;
                    //
                    let options = {};
                    options.callback = function () {
                        self.loginFlag = true;
                    };
                    MsgBox.warning(result.message, options);
                }
            });
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/entry/userLogin/main.vue